import { getTypedState } from 'ducks/hooks'
import { concatSeparator } from 'helpers'
import { Estimate, PaymentOption } from 'ducks/types'
import { NewEstimateType } from './types'

export const getNewEstimateStep = () => (): any => {
  const newEstimate = getTypedState().newEstimate
  return newEstimate?.step || 0
}

export const getNewEstimateValue = (type: string) => (): any => {
  const newEstimate = getTypedState().newEstimate
  if (!newEstimate) return null
  return newEstimate[type as keyof NewEstimateType] || null
}

export const getNewEstimateValues = () => (): Partial<NewEstimateType> => {
  const newEstimate = getTypedState().newEstimate
  return newEstimate || { address: {} }
}

export const getNewEstimateAddress = (): string => {
  const newEstimate = getTypedState().newEstimate
  if (!newEstimate?.address) return 'No address'
  const { city, line_1: street1, line1 } = newEstimate.address
  const address = concatSeparator(city ?? '', (street1 || line1 as string) ?? '', ', ')
  return address || 'No address'
}

export const getNewEstimateFullAddress = (): string => {
  const newEstimate = getTypedState().newEstimate
  if (!newEstimate?.address) return 'No address'
  const { city, line_1: street1, state, zipCode, line1 } = newEstimate.address
  let address = concatSeparator(street1 || line1 as string, city ?? '', ', ')
  address = concatSeparator(address, state + ' ' + zipCode, ', ')
  return concatSeparator(address, 'USA', ', ') || 'No address'
}

export const getNewEstimateData = () => (): Partial<Estimate> | null => {
  const newEstimate = getTypedState().newEstimate
  return newEstimate?.estimate ?? null
}

export const getNewEstimatePaymentOptions =
  () => (): PaymentOption[] | null => {
    const newEstimate = getTypedState().newEstimate
    return newEstimate?.paymentOptions ?? null
  }

export const getNewEstimatePaymentOptionById =
  (id: string) => (): PaymentOption | null => {
    const newEstimate = getTypedState().newEstimate
    return (
      newEstimate?.paymentOptions?.find((option: any) => option.id === id) ?? null
    )
  }

export const getNewEstimateSelectedOption = () => (): PaymentOption | null => {
  const newEstimate = getTypedState().newEstimate
  return newEstimate?.paymentOption ?? null
}

export const getNewEstimateExpediteOption = (selectedOption?: PaymentOption, paymentOptions?: PaymentOption[]) => (): PaymentOption | null => {
  const newEstimate = getTypedState().newEstimate
  const selected = selectedOption || newEstimate?.paymentOption
  if (!selected) return null
  return (
    paymentOptions?.find(
      (option) => option?.enable && option?.date < selected?.date
    ) ?? null
  )
}

export const getNewEstimateSubstep = () => (): any => {
  const newEstimate = getTypedState().newEstimate
  return newEstimate?.substep || 0
}

export const getNewEstimateOtherRequestsList = () => (): string => {
  const newEstimate = getTypedState().newEstimate
  return newEstimate?.otherRequestsList || ''
}

export const getNewEstimateOtherRequestsUpload = () => (): string => {
  const newEstimate = getTypedState().newEstimate
  return newEstimate?.otherRequestsUpload || ''
}

export const getNewEstimateItems = () => (): any[] => {
  const newEstimate = getTypedState().newEstimate
  return newEstimate?.items || []
}
